// extracted by mini-css-extract-plugin
export default {"content":"MarkdownChart_content__P+QAs","wrapper":"MarkdownChart_wrapper__HwGar"};